enum ConstituentQueryTypeFields {
  KANBAN = 'kanban',
  SIMPLE = 'simple',
  V2 = 'v2',
  V3 = 'v3',
  V4 = 'v4',
}

export default ConstituentQueryTypeFields;
